import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
class LoadBillerVXS extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  render() {
    let fdta = null;
    if(this.props.CreateOrder.Loaded && this.props.CreateOrder.Result.Code === 200) {
      fdta = this.props.CreateOrder.Result.Result;
      setTimeout(() => {
        this.billingForm.submit();
      },1000);
    }



    return (
      <React.Fragment>
        {!this.props.CreateOrder.Loaded &&
        <React.Fragment>
          <div className="large-text">{this.getTranslation("dash.pleasewait")}</div>
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
        </React.Fragment>
        }
        {this.props.CreateOrder.Loaded &&
        <div>
          <div className="large-text">{this.getTranslation("dash.pleasewait")}</div>
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
          {this.props.CreateOrder.Loaded && this.props.CreateOrder.Result.Code === 200 &&
          <form ref = {(ref) => this.billingForm = ref} action="https://secure.vxsbill.com/ezbill.php3" method="POST">
            <input type="hidden" name="order_id" value={fdta.OrderId} />
            <input type="hidden" name="user_1" value={fdta.Data[0]} />
            <input type="hidden" name="user_2" value={fdta.Data[1]} />
            <input type="hidden" name="city" value="" />
            <input type="hidden" name="country" value="" />
            <input type="hidden" name="zip" value="" />
            <input type="hidden" name="site" value={fdta.Data[2]} />
            <input type="hidden" name="layout" value="10" />
          </form>
          }
        </div>
        }

        <div className="secure-div">
          <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
        </div>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    CreateOrder: state.Billing.CreateOrder,

  };
}

export default connect(mapStateToProps)(LoadBillerVXS);




